import { Fields } from 'lib/fields';

export const EmptyFieldsDefaultValue: Record<Fields, any> = {
  recordtitlefield: ['Record 1', 'Record 2', 'Record 3'],
  textfield: ['Start one', 'hello world', 'lorem ipsiu'],
  textnestedfield: [],
  emailfield: ['asdasd@gmail.com', 'jon@smartsuite.com', 'Loren@smartsuite.com'],
  addressfield: [
    {
      location_address: '',
      location_address2: '',
      location_city: 'Southampton',
      location_state: 'England',
      location_zip: '',
      location_country: 'United Kingdom',
      location_longitude: '-1.4043509',
      location_latitude: '50.9097004',
      sys_root: 'Southampton, England, United Kingdom',
    },
    {
      location_address: '',
      location_address2: '',
      location_city: 'Rio de Janeiro',
      location_state: 'RJ',
      location_zip: '',
      location_country: 'Brazil',
      location_longitude: '-45.4043509',
      location_latitude: '-50.9097004',
      sys_root: 'Rio de Janeio, RJ, Brazil',
    },
    {
      location_address: '',
      location_address2: '',
      location_city: 'Bengaluru',
      location_state: 'Karnataka',
      location_zip: '',
      location_country: 'India',
      location_longitude: '95.4043509',
      location_latitude: '-50.9097004',
      sys_root: 'Bangalore, North Pradash, India',
    },
  ],
  textareafield: [
    'lorem ipsiu',
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  ],
  richtextareafield: [
    { data: {}, html: '<div class="rendered">\n    \n</div>' },
    { data: {}, html: '<div class="rendered">\n    \n</div>' },
    { data: {}, html: '<div class="rendered">\n    \n</div>' },
    {
      data: {
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                type: 'text',
                text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
              },
            ],
          },
          { type: 'paragraph', content: [{ type: 'text', text: 'asd' }] },
          { type: 'paragraph', content: [{ type: 'text', text: 'asd' }] },
          { type: 'paragraph', content: [{ type: 'text', text: '😄' }] },
          {
            type: 'paragraph',
            content: [
              {
                type: 'attachment',
                attrs: {
                  file: {
                    metadata: {
                      handle: 'q6cB50H0SoyUKk7CuvWg',
                      metadata: {
                        container: 'smart-suite-media',
                        filename:
                          'Captura de tela de 2020-03-16 21-29-26-you can delete those containers.png',
                        key: 'TSyizAsQfeewObSYugkM_Captura de tela de 2020-03-16 21-29-26-you can delete those containers.png',
                        mimetype: 'image/png',
                        size: 291826,
                      },
                      transform_options: {},
                      author: 4,
                      security: {
                        policy:
                          'eyJjYWxsIjogWyJyZWFkIiwgImNvbnZlcnQiXSwgImV4cGlyeSI6IDE1ODY5Nzg0MTQuMTkzMDg2LCAiaGFuZGxlIjogInE2Y0I1MEgwU295VUtrN0N1dldnIn0=',
                        signature:
                          'c103f766051c261061bc2de3d40ce0bda4d56606e58e63c29d1ea76e564e6ae1',
                      },
                      file_type: 'image',
                    },
                    handle: 'q6cB50H0SoyUKk7CuvWg',
                    security: {
                      policy:
                        'eyJjYWxsIjogWyJyZWFkIiwgImNvbnZlcnQiXSwgImV4cGlyeSI6IDE1ODY5Nzg0MTQuMTkzMDg2LCAiaGFuZGxlIjogInE2Y0I1MEgwU295VUtrN0N1dldnIn0=',
                      signature: 'c103f766051c261061bc2de3d40ce0bda4d56606e58e63c29d1ea76e564e6ae1',
                    },
                  },
                  float: 'none',
                },
              },
            ],
          },
        ],
      },
      html: '<div class="rendered">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#x27;s standard dummy text ever since the 1500s</p><p>asd</p><p>asd</p><p>😄</p><p>\n\n<a class="attachment-link" target="_blank" href="https://cdn.filestackcontent.com/security=p:eyJjYWxsIjogWyJyZWFkIiwgImNvbnZlcnQiXSwgImV4cGlyeSI6IDE1OTA1MjI4MDYuOTU3MzY5LCAiaGFuZGxlIjogInE2Y0I1MEgwU295VUtrN0N1dldnIn0=,s:78a050f320c507e8864466597840bc55f57e0b2b9e1d5e9222ad7aa43904675d/q6cB50H0SoyUKk7CuvWg">\n  <img src="data:image/svg+xml;base64,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">Captura de tela de 2020-03-16 21-29-26-you can delete those containers.png\n</a></p>\n</div>',
    },
    {
      data: {
        type: 'doc',
        content: [{ type: 'paragraph', content: [{ type: 'text', text: 'req textare RICH' }] }],
      },
      html: '<div class="rendered">\n    <p>req textare RICH</p>\n</div>',
    },
    {
      data: {
        type: 'doc',
        content: [{ type: 'paragraph', content: [{ type: 'text', text: 'rich comment 🥰' }] }],
      },
      html: '<div class="rendered">\n    <p>rich comment 🥰</p>\n</div>',
    },
  ],
  linkfield: [['http://www.google.com'], ['http://www.cnn.com'], ['http://www.smartsuite.com']],
  phonefield: [
    [
      {
        phone_country: '55',
        phone_number: '51 995702813',
        phone_extension: '44',
        phone_type: 2,
        sys_root: '05199570281344',
        sys_title: '+0 51 995702813 x44',
      },
    ],
    [
      {
        phone_country: '91',
        phone_number: '584981465849',
        phone_extension: '56',
        phone_type: 2,
        sys_root: '058498146584956',
        sys_title: '+0 584981465849 x56',
      },
    ],
    [
      {
        phone_country: '71',
        phone_number: '584981465849',
        phone_extension: '56',
        phone_type: 2,
        sys_root: '058498146584956',
        sys_title: '+0 584981465849 x56',
      },
    ],
  ],
  recordidfield: [
    '5ec5419c67c4fdea9360b5bf',
    '1ec5219c67c4fdea9360b5af',
    '3ec4219c67c4fdea9360b5ba',
  ],
  colorpickerfield: [
    [{ value: '#DD4040', name: 'Hello' }],
    [{ value: '#448353', name: 'Lorem' }],
    [{ value: '#228173', name: 'World' }],
  ],
  datefield: [
    '2020-03-18T16:53:21.743000Z',
    '2020-05-15T14:28:33.576000Z',
    '2020-05-15T14:28:50.364000Z',
  ],
  daterangefield: [
    {
      from_date: {
        date: '2021-09-01T00:00:00Z',
        include_time: false,
      },
      to_date: {
        date: '2021-09-03T00:00:00Z',
        include_time: false,
      },
    },
    {
      from_date: {
        date: '2021-09-01T12:15:00Z',
        include_time: true,
      },
      to_date: {
        date: '2021-09-03T19:00:00Z',
        include_time: true,
      },
    },
    {
      from_date: {
        date: null,
        include_time: false,
      },
      to_date: {
        date: null,
        include_time: false,
      },
    },
  ],
  durationfield: [
    { duration: 1800, time_unit: 'hours' },
    { duration: 10800, time_unit: 'minutes' },
    { duration: 7200, time_unit: 'seconds' },
  ],
  multipleselectfield: [['0', '1', '2'], ['1'], ['0', '1']],
  singleselectfield: ['1', '2', '3'],
  statusfield: ['in_progress', 'resolved', 'complete'].map((value) => ({ value })),
  tagsfield: ['done', 'resolved', 'TODO'],
  yesnofield: [true, false, true],
  ipaddressfield: [
    [{ country_code: '', address: '192.168.2.3' }],
    [{ country_code: '55', address: '255.155.244.122' }],
    [{ country_code: '11', address: '122.155.244.122' }],
  ],
  linkedrecordfield: [],
  userfield: [
    ['5dd812b9d8b7863532d3ddd2', '5e6ec7dadc8a90f33bcb02c9'],
    ['5e6ec7dadc8a90f33bcb02c9'],
  ],
  filefield: [
    {
      handle: 'b9JqU3JScO5xjhk2byXp',
      metadata: {
        container: 'smart-suite-media',
        filename: 'face.png',
        key: 'Ljq2vaRaSsGMlItnyFsN_face.png',
        mimetype: 'image/png',
        size: 543,
      },
      transform_options: {},
      security: {
        policy:
          'eyJjYWxsIjogWyJyZWFkIiwgImNvbnZlcnQiXSwgImV4cGlyeSI6IDE1OTA1ODkyNDAuMjM1MzI3LCAiaGFuZGxlIjogImI5SnFVM0pTY081eGpoazJieVhwIn0=',
        signature: '78ea081a5d18875a0fbd643fd9f96232d23ff6574a0af641ea79cf135f625cc6',
      },
      file_type: 'image',
      created_on: '2020-05-26T14:20:40.160000Z',
      updated_on: '2020-05-26T14:20:40.160000Z',
      description: null,
      record: { application_id: '5e6ec7d8dc8a90f33bcb02c1', record_id: '5e835a6fafaab1126309a57a' },
      icon: 'image',
    },
  ],
  signaturefield: [
    {
      text: null,
      drawing: [
        {
          handle: '29RDT91JTryByfGHiiWY',
          metadata: {
            container: 'smart-suite-media',
            filename: 'sign',
            key: 'VBIhdCpnSR6AmsxFEBM9_sign',
            mimetype: 'image/png',
            size: 3419,
          },
          transform_options: null,
          security: {
            policy:
              'eyJjYWxsIjogWyJyZWFkIiwgImNvbnZlcnQiXSwgImV4cGlyeSI6IDE1OTA1MjI1MDEuNjA5OTMxLCAiaGFuZGxlIjogIjI5UkRUOTFKVHJ5QnlmR0hpaVdZIn0=',
            signature: 'a54574263bb9fd54162248afb2b30695897a7a49cd87f17f5de8802b0a834664',
          },
          file_type: 'image',
          created_on: '2020-05-19T20:43:51.726000Z',
          updated_on: '2020-05-19T20:43:51.726000Z',
          description: null,
          record: { application_id: '5e6ec7d9dc8a90f33bcb02c8', record_id: 'None' },
          icon: 'image',
        },
      ],
      image_base64:
        'data:image/png;base64,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',
    },
    { text: 'henqie', drawing: [], image_base64: null },
    null,
  ],
  unknownfield: [],
  numberfield: ['0.10', '0.20', '3.00'],
  currencyfield: ['232.00$', '2.00R$', '2222222222223.00$'],
  percentfield: [10, 20.05, 99],
  autonumberfield: [1, 2, 3],
  votefield: [
    { total_votes: 1, votes: [{ user_id: '5e6ec7dadc8a90f33bcb02c9', date: '2020-05-22' }] },
  ],
  numbersliderfield: [10, 20, 30],
  ratingfield: [5, 4, 1],
  availabilitystatusfield: [],
  socialnetworkfield: [
    { instagram_username: 'zzeuquiunehh', sys_root: 'zzeuquiunehh' },
    { instagram_username: 'souza', sys_root: 'souza' },
    {
      facebook_username: 'agente',
      twitter_username: 'Loren',
      linkedin_username: 'asd',
      instagram_username: 'World',
      sys_root: 'agente, Loren, asd, World',
    },
  ],
  timefield: ['17:30:00', '03:45:01', '00:01:00'],
  firstcreatedfield: [
    {
      on: '2020-06-05T22:46:20.336000Z',
      by: '5ec1df770a8617c27a73e3c3',
    },
    {
      on: '2014-06-05T22:42:20.336000Z',
      by: '2ec1df170a8617c27a73e3c1',
    },
    {
      on: '2014-02-05T22:42:20.336000Z',
      by: '3ec1df170a8617c27a73e3c3',
    },
  ],
  lastupdatedfield: [
    {
      on: '2020-06-19T19:11:46.042000Z',
      by: '5ec1df770a8617c27a73e3c3',
    },
    {
      on: '2030-06-19T19:11:46.042000Z',
      by: '3ec1df770a8617c27a73e3c1',
    },
    {
      on: '2000-06-19T19:11:46.042000Z',
      by: '1ec1df770a8617c27a73e3c3',
    },
  ],
  duedatefield: [
    {
      from_date: {
        date: '2021-09-03T03:00:00Z',
        include_time: true,
      },
      to_date: {
        date: '2021-09-04T03:15:00Z',
        include_time: true,
      },
      is_overdue: false,
    },
    {
      from_date: {
        date: '2021-09-01T16:45:00Z',
        include_time: true,
      },
      to_date: {
        date: '2021-09-03T06:00:00Z',
        include_time: true,
      },
      is_overdue: true,
    },
  ],
  percentcompletefield: ['1.00', '45.55', '120.00'],
  checklistfield: [
    {
      items: [
        {
          id: '04187e66-57ca-4bc3-a797-29ff51bb1677',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'Item 1',
                    },
                  ],
                },
              ],
            },
            html: '<div class="rendered">\n    <p>Item 1</p>\n</div>',
            preview: '',
          },
          completed: false,
          assignee: null,
          due_date: null,
          completed_at: null,
        },
        {
          id: 'd4f0fa22-42be-4bda-add7-32c80c0f661d',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'Item 2',
                    },
                  ],
                },
              ],
            },
            html: '<p>Item 2</p>',
            preview: '',
          },
          completed: true,
          assignee: null,
          due_date: null,
          completed_at: '2021-09-03T20:59:46.855Z',
        },
      ],
      total_items: 2,
      completed_items: 1,
    },
    {
      items: [
        {
          id: '11b91bae-b51b-4e3c-9291-46ce4de13143',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'First Item',
                    },
                  ],
                },
              ],
            },
            html: '<div class="rendered">\n    <p>First Item</p>\n</div>',
            preview: '',
          },
          completed: true,
          assignee: null,
          due_date: null,
          completed_at: '2021-09-03T21:23:30.778Z',
        },
        {
          id: 'ca80c81f-1c26-407e-aacd-1c91a8f026ff',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'Second Item',
                    },
                  ],
                },
              ],
            },
            html: '<p>Second Item</p>',
            preview: '',
          },
          completed: true,
          assignee: null,
          due_date: null,
          completed_at: '2021-09-03T21:23:30.543Z',
        },
      ],
      total_items: 2,
      completed_items: 2,
    },
    {
      items: [
        {
          id: '262bc7b8-d6b5-4a15-b5cf-3186dd7b5c55',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'Checklist Item 1',
                    },
                  ],
                },
              ],
            },
            html: '<div class="rendered">\n    <p>Checklist Item 1</p>\n</div>',
            preview: '',
          },
          completed: false,
          assignee: '610c1daa5300ca665651fdc5',
          due_date: '2021-09-03T00:00:00Z',
          completed_at: null,
        },
        {
          id: 'ecbda0bf-ed73-46c0-a220-1bde2585728b',
          content: {
            data: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      text: 'Another Checklist Item',
                    },
                  ],
                },
              ],
            },
            html: '<p>Another Checklist Item</p>',
            preview: '',
          },
          completed: false,
          assignee: null,
          due_date: null,
          completed_at: null,
        },
      ],
      total_items: 2,
      completed_items: 0,
    },
  ],
  countfield: ['1', '1', '1'],
  rollupfield: [1, 2, 3],
  lookupfield: [],
  formulafield: [],
  timetrackingfield: [
    {
      time_track_logs: [
        {
          user_id: '610c1daa5300ca665651fdc5',
          date_time: '2021-09-03T17:58:54Z',
          duration: 1800,
          time_range: null,
          note: 'An example of a note',
        },
      ],
      total_duration: 1800,
    },
    {
      time_track_logs: [
        {
          user_id: '610c1daa5300ca665651fdc5',
          date_time: '2021-09-03T12:00:00Z',
          duration: 5400,
          time_range: null,
          note: 'Some note about time tracking',
        },
      ],
      total_duration: 5400,
    },
    {
      time_track_logs: [
        {
          user_id: '610c1daa5300ca665651fdc5',
          date_time: '2021-09-03T18:24:14Z',
          duration: 22500,
          time_range: {
            _cls: 'DateRangeDocument',
            from_date: {
              date: '2021-09-03T01:00:00Z',
              include_time: false,
            },
            to_date: {
              date: '2021-09-03T07:15:00Z',
              include_time: false,
            },
          },
          note: 'Time Tracking Note',
        },
      ],
      total_duration: 22500,
    },
  ],
  fullnamefield: [
    {
      first_name: 'recode mindais',
      middle_name: '',
      last_name: 'last words',
      title: '',
      sys_root: 'recode mindais last words',
    },
    { first_name: 'first', middle_name: '', last_name: 'last', title: '', sys_root: 'first last' },
    { first_name: 'first', middle_name: '', last_name: 'last', title: '', sys_root: 'first last' },
  ],
  commentscountfield: [1, 2, 3],
  subitemsfield: [
    [],
    [
      {
        id: '8db1067e776a49cb91b2ca8a',
        name: 'sub 1',
        description: 'item',
        date: { date: '2021-01-01T00:00:00Z', include_time: false },
      },
    ],
    [
      {
        id: '8db1067e776a49cb91b2ca8a',
        name: 'sub 1',
        description: 'item',
        date: { date: '2021-01-01T00:00:00Z', include_time: false },
      },
      {
        id: '8db1067e776a49cb91b2ca8a',
        name: 'sub 2',
        description: 'item 2',
        date: { date: '2021-01-02T00:00:00Z', include_time: false },
      },
    ],
  ],
  buttonfield: [null],
};
